module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "display-flex justify-space-between align-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/mobile/icon/arrow-left.svg"),
      "width": "9",
      "height": "18"
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'YouMobile'
        })
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require('@/assets/ys_logo_primary-black.svg'),
      "width": "100"
    }
  }), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "text-dmsans-14 text-white d-flex justify-center align-center font-weight-500 my-4 error full-width"
  }, [_vm._v("\n    Checkout error\n  ")]), _vm._v(" "), _c('Card', {
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'ConfirmationMobile'
        })
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72fc960b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/new-mobile/checkout.vue
// module id = 1775
// module chunks = 180